export const SPEED_ARG = 0.0058;

export const DEFAULT_TRACK_SIZE = 12;

export const DEFAULT_RENDER_INTERVAL = 150;

export const defaultRollingBoardData = {
  msg: '',
  fontSize: 24,
  fontColor: '#ffffff',
  fontMode: 'roll',
  fontArea: 'full',
  fontAreaPercent: 0.25,
  rollTime: 0,
  rolledDistance: 0,
  top: 0
};
